<template>
  <div>
    <ml-table
      :data-source="dataSource"
      :columns="columns"
      :scroll="{ y: dataSource && dataSource.length > 4 ? 200 : 0, x: 1900 }"
      size="small"
    >
      <!-- row-key="materialId" -->
      <template slot="actions" slot-scope="text, record">
        <a-popconfirm
          :title="$t('page_mdc_setting_sure_delete')"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">{{ $t('delete') }}</a>
        </a-popconfirm>
      </template>
      <template slot="material" slot-scope="text, record">
        <a-select
          show-search
          style="width:100%"
          :value="record.materialName"
          :filter-option="false"
          @search="(value) => getMaterialList(value)"
          @change="(value) => onChange(value, record.key)"
        >
          <template v-for="(material, index) in filterMaterialList">
            <a-select-option :value="material.value" :key="index" :disabled="material.disabled">
              {{ material.label }}
            </a-select-option>
          </template>
        </a-select>
      </template>
      <template slot="stockOutNum" slot-scope="text, record">
        <a-input-number :min="0" :max="999999999" v-model="record.stockOutNum" />
      </template>
      <template slot="issue" slot-scope="text, record">
        <a-select
          v-if="Number(text) != 2"
          show-search
          style="width:100%"
          :value="record.issue"
          @change="(value) => onChangeIssue(value, record.key)"
        >
          <a-select-option :value="0">
            {{ $t('yes') }}
          </a-select-option>
          <a-select-option :value="1">
            {{ $t('no') }}
          </a-select-option>
        </a-select>
      </template>
    </ml-table>
    <a-button type="primary" style="width: 100%;margin-top: 8px;" @click="handleAdd">
      {{ $t('page_plan_maintenance_add_spare_parts') }}
    </a-button>
  </div>
</template>

<script>
import { WarehouseMaterialStockServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'

const wmsp = new WarehouseMaterialStockServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'actions' }
  },
  {
    title: 'page_material_ware_out_code',
    dataIndex: 'orderCode',
    key: 'orderCode',
    width: 200,
    scopedSlots: { customRender: 'orderCode' }
  },
  {
    title: 'page_business_material_property_spare_parts',
    dataIndex: 'materialId',
    key: 'materialId',
    width: 200,
    scopedSlots: { customRender: 'material' }
  },
  {
    title: 'page_material_check_area',
    dataIndex: 'areaName',
    width: 200,
    ellipsis: true
  },
  {
    title: 'page_material_check_location',
    dataIndex: 'locationName',
    width: 200,
    ellipsis: true
  },
  {
    title: 'page_plan_total_inventory',
    dataIndex: 'stockSumNum',
    key: 'stockSumNum',
    width: 200,
    scopedSlots: { customRender: 'stockSumNum' }
  },
  {
    title: 'page_tpm_record_table_location_num',
    dataIndex: 'locationNum',
    key: 'locationNum',
    width: 200,
    scopedSlots: { customRender: 'locationNum' }
  },
  {
    title: 'page_plan_delivery_quantity',
    dataIndex: 'stockOutNum',
    key: 'stockOutNum',
    width: 200,
    scopedSlots: { customRender: 'stockOutNum' }
  },
  {
    title: 'page_tpm_record_table_issue',
    dataIndex: 'issue',
    key: 'issue',
    width: 200,
    scopedSlots: { customRender: 'issue' }
  }
]
export default {
  data() {
    return {
      dataSource: [],
      count: 0,
      first: true,
      materialList: [],
      filterMaterialList: []
    }
  },
  props: {
    changeSparepartsList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    changeSparepartsList: {
      handler() {
        this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    getData() {
      this.dataSource = this.changeSparepartsList
      this.count = this.dataSource.length
      if (this.first) {
        this.$emit('change', this.dataSource)
        this.first = false
      }
      this.getMaterialList()
    },
    getMaterialList(value) {
      const values = {
        keyWord: value,
        property: 4,
        typeId: ''
      }
      wmsp.getStockMaterial(values).then((res) => {
        this.materialList = res
        this.filterMaterialList = res.map((item) => ({
          label: item.name + '(' + item.areaName + '-' + item.locationName + ')',
          value: item.materialId + item.areaId + item.locationId
        }))
      })
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== key)
      this.$emit('change', this.dataSource)
    },
    handleChange(value, key, col) {
      const has = this.dataSource.find((res) => res.materialCode === value)
      if (has != undefined) {
        this.$message.warning(this.$t('page_plan_spare_parts_not_choose_same'))
        return
      }
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      const data = this.materialList.find((res) => res.code === value)
      if (target) {
        target[col] = value
        if (col === 'materialCode') {
          console.log(data)
          target['materialId'] = data.id
          target['materialName'] = data.name
        }
        this.dataSource = newData
        this.$emit('change', this.dataSource)
      }
    },
    onChange(value, key) {
      const has = this.dataSource.find(
        (item) => item.materialId + item.areaId + item.locationId === value
      )
      if (has != undefined) {
        this.$message.warning(this.$t('page_plan_spare_parts_not_choose_same'))
        return
      }
      let material = this.materialList.find(
        (item) => item.materialId + item.areaId + item.locationId === value
      )
      let temp = [...this.dataSource]
      temp.map((item) => {
        if (item.key === key) {
          item.materialId = material.materialId
          item.materialCode = material.code
          item.materialName = material.name
          item.areaId = material.areaId
          item.locationId = material.locationId
          item.areaName = material.areaName
          item.locationName = material.locationName
          item.stockSumNum = material.stockSumNum
          item.locationNum = material.locationNum
        }
      })
      this.dataSource = [...temp]
      this.$emit('change', this.dataSource)
    },
    onChangeIssue(value, key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target['issue'] = value
        this.dataSource = newData
        this.$emit('change', this.dataSource)
      }
    },
    handleAdd() {
      const { count, dataSource } = this
      const newData = {
        key: count,
        materialCode: '',
        materialId: '',
        materialName: '',
        number: 0
      }
      this.first = false
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    }
  }
}
</script>
